import { useBreakpointsContext } from './BreakpointsContext';
export const useAdaptiveValue = () => {
  const {
    match
  } = useBreakpointsContext();
  return match;
};